import React from 'react';
import { Link } from 'react-router-dom';

function Projects() {
  return (
    <section className="page projects-page">
      <h1>Work</h1>
      <p className="projects-intro">A curated selection of projects.</p>

      <ul className="project-tile-grid">
        <li>
          <Link to="/scrunch-demo" className="project-tile">
            <h2>Web Content Retriever</h2>
            <h3>Safe, structured retrieval for any public web page.</h3>
            <h4>FastAPI, robots.txt policy, SSRF protection, bounded retries, rate limiting, and optional AI extraction.</h4>
            <p className="project-tile-tldr">
              A password-protected interactive console for inspecting metadata, raw HTML, redirect
              destinations, structured responses, and deterministic failure cases.
            </p>
            <span className="project-tile-cta">Open project →</span>
          </Link>
        </li>
        <li>
          <Link to="/projects/demodock" className="project-tile">
            <h2>Demo Dock</h2>
            <h3>Personalized Demos. Zero Engineering.</h3>
            <h4>The AI-powered "Magic Overlay" that turns your production site into a custom
              experimental sandbox in one click.</h4>
            <p className="project-tile-tldr">
              Split-screen sales demos: AI-style chat + proxied site iframe with a postMessage bridge
              for safe, scripted DOM updates (e.g. change headlines for the room).
            </p>
            <span className="project-tile-cta">Open project →</span>
          </Link>
        </li>
        <li>
          <Link to="/projects/chloromance-tracker" className="project-tile">
            <h2>Chloromance Plant Tracker</h2>
            <h3>Weather-aware plant care with account-backed sync.</h3>
            <h4>WiltPower scoring, Supabase plant backup, browser reminders, and batch watering by location.</h4>
            <p className="project-tile-tldr">
              A signed-in plant dashboard that calculates live hydration status from watering timestamps,
              adapts urgency with Open-Meteo weather, and keeps local data resilient with cloud backup.
            </p>
            <span className="project-tile-cta">Open project →</span>
          </Link>
        </li>
        <li>
          <Link to="/projects/wardrobe" className="project-tile">
            <h2>FIT HAPPENS</h2>
            <h3>What to wear? Consider it handled.</h3>
            <h4>Local inventory, care and location tracking, real-photo outfits, and deterministic recommendations.</h4>
            <p className="project-tile-tldr">
              A browser-local companion to the native SwiftUI app, designed around truthful availability,
              optional NFC garment tags, explainable styling, and portable user-owned data.
            </p>
            <span className="project-tile-cta">Open project →</span>
          </Link>
        </li>
        <li>
          <Link to="/projects/localization-control-plane" className="project-tile">
            <h2>Localization Control Plane</h2>
            <h3>AI scale with policy-controlled publication.</h3>
            <h4>One governed localization platform across static UI, security data, AI assistant output, and CMS content.</h4>
            <p className="project-tile-tldr">
              Demonstrates terminology governance, translation memory, deterministic QA, semantic QE, review exceptions,
              audit provenance, RTL handling, and i18n readiness scanning in mock mode.
            </p>
            <span className="project-tile-cta">Open project →</span>
          </Link>
        </li>
        <li>
          <Link to="/projects/brainpocket" className="project-tile">
            <h2>BrainPocket</h2>
            <h3>Local-first article archiving.</h3>
            <h4>Domain trees, article nodes, and key-point leaves stored in browser localStorage.</h4>
            <p className="project-tile-tldr">
              A no-backend knowledge pocket for saving URLs, grouping them by source domain, and
              building a compact tree of notes around each article.
            </p>
            <span className="project-tile-cta">Open project →</span>
          </Link>
        </li>
        <li>
          <Link to="/projects/wheel-of-chores" className="project-tile">
            <h2>Wheel of Chores</h2>
            <h3>Household chore wheels with person-aware rewards.</h3>
            <h4>Daily, weekly, and monthly tasks can be assigned to one or more people, then packed into a time-budgeted wheel.</h4>
            <p className="project-tile-tldr">
              A local-first chore planner for shared households, with per-person chore lists, completion history,
              Chore Coin balances, and a Capacitor-friendly mobile app shell.
            </p>
            <span className="project-tile-cta">Open project →</span>
          </Link>
        </li>
        <li>
          <Link to="/projects/flow-pet-rpg" className="project-tile">
            <h2>Flow Pet RPG</h2>
            <h3>A focus timer that raises a tiny RPG companion.</h3>
            <h4>Web Worker countdowns, tab-neglect rules, pet evolution, loot chests, and costume equipment.</h4>
            <p className="project-tile-tldr">
              A local-first focus dashboard where completed quests grant EXP, unlock gear, and evolve
              your pet from an interactive egg into a fully equipped final form.
            </p>
            <span className="project-tile-cta">Open project →</span>
          </Link>
        </li>
        <li>
          <Link to="/projects/meal-planner" className="project-tile">
            <h2>Budget Meal Planner</h2>
            <h3>Strict-cap weekly plans from fridge inventory and store prices.</h3>
            <h4>Delta shopping, package-size optimization, leftovers, and batch prep modes.</h4>
            <p className="project-tile-tldr">
              A Capacitor-friendly React planner that converts owned ingredients, scraped supermarket
              products, and recipes into a weekly calendar and aisle-grouped checklist.
            </p>
            <span className="project-tile-cta">Open project</span>
          </Link>
        </li>
      </ul>
    </section>
  );
}

export default Projects;
